import React, { Component } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
// import { obfuscatedCoordinates } from '../../util/maps';  // ya no se usa
// import { Heading, Map } from '../../components';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData /*, listingId, mapsConfig */ } =
      this.props;

    // Intentamos obtener una dirección legible desde distintos campos posibles
    const address =
      publicData?.location?.selectedPlace?.address ||
      publicData?.requestLocation?.selectedPlace?.address ||
      publicData?.location?.address ||
      '';

    // Si no hay ni dirección ni coordenadas, no mostramos la sección
    if (!address && !geolocation) {
      return null;
    }

    const classes = classNames(rootClassName || css.sectionMap, className);

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>

        {/* En lugar del mapa, mostramos solo el texto de la dirección */}
        <div style={{ fontSize: '1rem', lineHeight: 1.5, marginTop: 8 }}>
          {address || `${geolocation.lat}, ${geolocation.lng}`}
        </div>
      </section>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
};

export default SectionMapMaybe;
